import $ from 'jquery';

class Shapes {
  init() {
    this.shapesElements = $('.has-shape');

    if (!this.shapesElements.length) {
      return;
    }

    this.iconsData = {
      'circle-striped-yellow': {
        viewBox: '0 0 373 373',
        fill: '#ffcc3e',
      },
      'circle-striped-pink': {
        viewBox: '0 0 373 373',
        fill: '#ff7160',
      },
      'circle-striped-thick-yellow': {
        viewBox: '0 0 255 254',
        fill: '#ffcc3e',
      },
      'circle-striped-thick-pink': {
        viewBox: '0 0 255 254',
        fill: '#ff7160',
      },
      'circles-top-right': {
        viewBox: '0 0 403 345',
      },
      'circles-top-left': {
        viewBox: '0 0 403 345',
      },
      'circles-bottom-right': {
        viewBox: '0 0 368 317',
      },
      'circles-bottom-left': {
        viewBox: '0 0 368 317',
      },
    };

    this.shapesElements.each((i, el) => {
      const element = $(el);
      const figure = Shapes.getFigureElement(element);

      if (figure && figure.length && !figure.find('.c-image-shape').length) {
        let shapeType = '';
        const classes = element
          .attr('class')
          .split(' ')
          .filter(value => value.match(/(\bhas-shape-.+\b)/))
          .map(value => {
            const getShapeType = value.match(/has-shape-(.+)/);

            if (getShapeType.length > 1) {
              [, shapeType] = getShapeType;
            }
            return value.replace(/(has-shape-)(.+)/, 'c-image-shape--$2');
          });

        classes.push('c-image-shape');

        const img = figure.find('img');

        if (img.length && shapeType) {
          if (!img.parent().hasClass('c-image-shape-wrap')) {
            img.wrap('<div class="c-image-shape-wrap"></div>');
          }
          const shape = this.getShapeIcon(shapeType);
          figure.find('.c-image-shape-wrap').append(
            $('<span></span>', {
              class: classes.join(' '),
              html: shape,
            }),
          );
        }
      }
    });
  }

  getShapeIcon(type) {
    if (typeof this.iconsData[type] === 'undefined') {
      return '';
    }

    const fill =
      typeof this.iconsData[type].fill !== 'undefined'
        ? `fill="${this.iconsData[type].fill}"`
        : '';

    const viewBox =
      typeof this.iconsData[type].viewBox !== 'undefined'
        ? `viewBox="${this.iconsData[type].viewBox}"`
        : '';

    const shapeType = type.replace(
      /(circle-striped)(-thick)?(-.+)/,
      'circle-striped$2',
    );

    return `<span class="c-svg-icon c-svg-icon--${shapeType}" aria-hidden="true">
      <svg ${fill} class="c-icon c-icon--${shapeType}" preserveAspectRatio="xMidYMid meet" width="100%" height="100%" ${viewBox}>
        <use xlink:href="#c-icon--${shapeType}"></use>
      </svg>
    </span>`;
  }

  static getFigureElement(element) {
    let figure = null;

    if (element.hasClass('wp-block-media-text')) {
      figure = element.find('.wp-block-media-text__media');
    } else if (element.hasClass('wp-block-image')) {
      if (element.find('figure').length) {
        figure = element.find('figure');
      } else {
        figure = element;
      }
    } else if (element.hasClass('wp-block')) {
      figure = element.find('figure');
    }

    return figure;
  }

  refresh() {
    setTimeout(() => {
      this.isRefresh = true;
      this.shapesElements = $('.has-shape');
      this.shapesElements.each((i, el) => {
        const element = $(el);
        const figure = Shapes.getFigureElement(element);

        if (figure && figure.length && figure.find('.c-image-shape').length) {
          figure.find('.c-image-shape').remove();
        }
      });

      this.init();
    }, 100);
  }

  circles() {
    this.circleShapes = $('.c-image-shape--circle');

    if (this.circleShapes.length) {
      $(document).on('lazyloaded', e => {
        const image = $(e.target);

        if (image.closest('.has-shape-circle').length) {
          const circle = image
            .closest('.has-shape-circle')
            .find('.c-image-shape--circle');

          circle.css({
            width: circle.height(),
          });
        }
      });

      let debounce = null;
      $(window).on('resize load', () => {
        clearTimeout(debounce);

        debounce = setTimeout(() => {
          $.each(this.circleShapes, (i, el) => {
            const circle = $(el);

            circle.css({
              width: circle.height(),
            });
          });
        }, 250);
      });

      if (this.isRefresh) {
        $.each(this.circleShapes, (i, el) => {
          const circle = $(el);

          circle.css({
            width: circle.height(),
          });
        });
      }
    }
  }
}

export default Shapes;



// WEBPACK FOOTER //
// ./src/scripts/modules/images-shapes.js